import { render } from "./HelpCenterButton.vue?vue&type=template&id=0abe13da"
import script from "./HelpCenterButton.vue?vue&type=script&lang=js"
export * from "./HelpCenterButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__